<template>
	<div class="Analytics"
		v-loading.fullscreen.lock="$GVO.fullscreenLoading"
		element-loading-text="Загрузка данных..."
		element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<h2>Отчеты</h2>



		<!--
		<pre>{{ myobj_data }}</pre>
		-->

		<ReReportForm
			:objGetParams="objGetParams"
			:obj="obj"
			:strTags="this.strTags"
			:tags="this.massTags"
			:isFilterDirty="isFilterDirty"
			@filterFields="updateFilterFields"
			:download=true
			:download_pdf=true
			:download_html=true
		>
			<div class="my-2">
				<div class="filter-tag-row flex">
					<div>
						<ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
					</div>
					<div class="flex1">
						<span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Объектов: {{this.masObjects_total}}</span>
					</div>
					<div class="flex-end">
						<ReConfigButton v-if="$GVO.my_profile.adm == 1" obj="analytics"/>
					</div>
				</div>	
				<div class="col-lg-8" v-show="bShowFilter">
					<ReFilter :masAllFilterParams="masAllFilterParams" 
						v-model="objGetParams" 
						v-on:filterapply="OnFilterApply"
						@value-change="valueChange"
					/>
				</div>
			</div>	
		</ReReportForm>

		<!-- Скрыто для презентации отчетов. Артем.-->
		<!-- <div>
			<h3>Пример данных из фильтра</h3>
			<el-table ref="multipleTable" :data="myobj_data">
				<el-table-column v-for="col in myobj_cols" :property="col.prop" :label="col.name">
				</el-table-column>
			</el-table>
		</div> -->
		
	</div>
</template>

<script>
	import {eventEmitter} from "src/plugins/globalComponents.js";
	// import { TabPane, Tabs, BaseSwitch } from 'src/components';
	import { Table, TableColumn } from 'element-ui';

	import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
	import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
	import ReReportForm from 'src/our_components/ReReportForm.vue';
	import ReConfigButton from "../our_components/ReConfigButton.vue";


	export default {
		name: 'analytics-page',
		components: {
			// TabPane, 
			// Tabs,
			[Table.name]: Table,
			[TableColumn.name]: TableColumn,
			// BaseSwitch,
			ReReportForm,
			ReFilterBtn,
			ReFilter,
			ReConfigButton,
		},
		props: {
			
		}, 
		
		data() {
			return {
				obj: 'analytics', //class, LEAD
				massTags: [],
				strTags: '',
				objGetParams: {},
				bShowFilter: true,
				masAllFilterParams: this.currentFilterConfig(),
				masObjects_total: 0,
				myobj_data:[],
				myobj_cols:[],
				filterFilterFields:[],
				// filterChanged: false,
				isFilterDirty: false,
    		}
		},
		methods: {
			updateFilterFields(list){
				this.filterFilterFields = list;
				this.refreshFilters();
			},
			refreshFilters(){
				if(this.filterFilterFields.length==0){
					this.masAllFilterParams = this.allFilters;
				}else{
					const filteredFilters = this.allFilters.map(filter => {
						if (Array.isArray(filter.elements)) {
							// Фильтруем элементы внутри каждого объекта
							const filteredElements = filter.elements.filter(element =>
								this.filterFilterFields.includes(element.elementGetParamMap)
							);

							// Возвращаем новый объект с отфильтрованными elements
							return {
								...filter,
								elements: filteredElements
							};
						}
						// Если elements не массив, возвращаем исходный объект без изменений
						return filter;
					});	
					this.masAllFilterParams = filteredFilters;				
				}
				eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);

			},
			valueChange(data){
				// console.log('data valueChange',data);
				this.strTags = '';
				this.massTags = [];
				this.isFilterDirty = true;
				// this.filterChanged = true;
			},
			PushTags(data){
				// функцию навесить на комопнент фильтра v-on:PushTags="PushTags" и еще на фильтр :tags="true"
				this.massTags = data;

				let smtharray = [];
				if(this.massTags.length > 0){
					for (let i = 0;  i < this.massTags.length; i++) {
						if(this.massTags[i].param_id!='work_time'){ 
							smtharray.push(`${this.massTags[i].name} : ${this.massTags[i].val}`);
						}else if (this.massTags[i].param_id=='work_time' && this.massTags[i].val == 1){
							smtharray.push(`${this.massTags[i].name} : Да`);
						}else if (this.massTags[i].param_id=='work_time' && this.massTags[i].val == 0){
							//кажется в фильтре в теге не пишется ничего, если его val 0
							smtharray.push(`${this.massTags[i].name} : Нет`);
						}
						
					}
				}
				this.strTags = smtharray.join('; ');
				//console.log('this.massTags', this.massTags );
			},
			OnFilterApply(data){
				//console.log('OnFilterApply_data',data);
				//console.log('OnFilterApply',this.objGetParams);
				/*
				let bFromObj = false;
				if(SGVO.prevRoute != null) 
					if(SGVO.prevRoute.indexOf('/callcenter/id/')>0) bFromObj = true;

				if(typeof data != 'undefined' && typeof this.objGetParams['p'] != 'undefined' && bFromObj==false){
					delete this.objGetParams['p'];
				}
				SGVO.prevRoute=null;		
				*/

				for (const key in this.objGetParams) {
					if (Object.hasOwnProperty.call(this.objGetParams, key)) {
						if(this.objGetParams[key] == '') delete this.objGetParams[key];
						if(this.objGetParams[key] == '{"inputText":"","selectedVal":""}') delete this.objGetParams[key];
					}
				}
				

				let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
				//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
				this.$router.push({path: location.pathname+'?'+strItogGetParams});
				eventEmitter.$emit('OnFilterApply', this.objGetParams);
				// this.getData();
				// this.filterChanged = false;
				this.isFilterDirty = false;
			},
			currentFilterConfig(){
				this.$GVO.ApiCall('analytics.GET_FILTER_MYOBJ',{})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						// this.masAllFilterParams = objApi.config;
						this.allFilters = this.$GVO.unlinkObject(objApi.config);
						this.refreshFilters();
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
				
				return [];
			},
			getData(){
				this.objGetParams = this.$GVO.GetAllGet();
				let filter = {};
				if (!this.$GVO.isEmpty(this.objGetParams)) {
					//console.log('getClients',this.objGetParams);
					filter = this.objGetParams;
				}
				//console.log('getClients',filter);
				this.$GVO.ApiCall('analytics.GET_MYOBJ',{flt:{...filter} })
				.then((objApi) => { 
					this.myobj_data = [];
					this.masObjects_total = 0;
					if(objApi.success === true){ //console.log(objApi);
						this.myobj_data = objApi.data;
						this.myobj_cols =  objApi.fields;
						if(objApi.total!=undefined) { this.masObjects_total=objApi.total; }
					}else{
						this.myobj_data = [];
						//this.openFullScreen1();
					}
				}).catch((errorObjApi) => {console.error(errorObjApi); this.myobj_data = [];});
			},
		// getCallCenterData(){
		// 	this.objGetParams = this.$GVO.GetAllGet();
		// 	let filter = {};
		// 	let sortOrder = {};
		// 	if (!this.$GVO.isEmpty(this.objGetParams)) {
		// 		//console.log('getCallCenterData',this.objGetParams);
		// 		filter = this.objGetParams;
		// 	} 

		// 	this.$GVO.ApiCall('LEAD.GET',{flt:{...filter,...sortOrder, act:1, }}) // 'list':true,
		// 		.then((objApi) => {
		// 			// console.log(objApi);
		// 			this.ApiCallCenter = [];
		// 			this.masObjects_total = 0;

		// 			if(objApi.success){
						
		// 				this.ApiCallCenter = objApi.data;
		// 				if(objApi.total!=undefined) { this.masObjects_total=objApi.total; }

		// 			} else {
		// 				this.ApiCallCenter = [];
		// 				this.masObjects_total=0;
		// 			}
		// 		})
		// 		.catch(errorObjApi => {this.ApiCallCenter = []; this.masObjects_total=0; console.log(errorObjApi);});
		// },


		},
		mounted() {
			
		}
	};
</script>

<style scoped lang="scss">
	.flex{display:flex;}
	.flex1{
		flex:1
	}
</style>
